import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { integrationSchemaRegistry } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { GuardDutyFeature } from '../../lib/constants';
import { GuarddutyService } from '../../service';

export type GuarddutyReportConfig = typeof GuarddutyReportConfig._.Config;

export const GuarddutyReportConfig = IntegrationConfig.make({
  service: GuarddutyService,
  name: Integration_Handler_Names_Enum.GuarddutyReport,
  configSchema: z.object({
    highSeverityFindings: z.object().optional(),
    snsSubscription: z.object().optional(),
    enabledFeatures: z
      .object({
        features: z
          .array(
            z.enum(GuardDutyFeature).register(integrationSchemaRegistry, {
              i18n: 'integrations.aws.services.guardduty.shared.guardduty_feature',
            }),
          )
          .optional(),
      })
      .optional(),
  }),
});
